import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2 border border-gray rounded-lg bg-white p-4 lg:p-10" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("AW/34567000")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "border-gray-stroke border-b-2 mt-8 mb-4" }, null, -1)
const _hoisted_5 = { class: "grid grid-cols-2 lg:grid-cols-3 text-sm lg:text-base font-basier" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Nazwa Dostawcy Sp. z o.o."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 60-164 Poznań"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ul. Testowa 1a/36 ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Nazwa Odbiorcy"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 60-164 Poznań"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ul. Testowa 1a/36 ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Jan Nowak", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "PO 789456", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "26,7 t", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " 20.04.2021 ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " 20.04.2021 ", -1)

import { CardIconText, CardText } from '@/components/card'
import { UiTitle } from '@/components/common/ui'
import { DropdownMenu, MenuDots } from '@/components/dropdownMenu'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_IconWheel = _resolveComponent("IconWheel")!
  const _component_IconTruck = _resolveComponent("IconTruck")!
  const _component_IconWeight = _resolveComponent("IconWeight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(UiTitle), null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_unref(DropdownMenu), { items: [
                    {
                        label: 'Użytkownicy',
                    },
                    {
                        label: 'Kierowcy',
                    },
                    {
                        label: 'Nr rejestracyjne',
                    },
                ] }, {
        "menu-button": _withCtx(() => [
          _createVNode(_unref(MenuDots))
        ]),
        _: 1
      })
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(CardText), { title: "Załadunek" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_unref(CardText), { title: "Rozładunek" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_unref(CardText), { title: "Transport" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardIconText), null, {
            default: _withCtx(() => [
              _createVNode(_component_IconWheel),
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_unref(CardIconText), null, {
            default: _withCtx(() => [
              _createVNode(_component_IconTruck),
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_unref(CardIconText), null, {
            default: _withCtx(() => [
              _createVNode(_component_IconWeight),
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(CardText), {
        title: "Data załadunku",
        bold: true
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }),
      _createVNode(_unref(CardText), {
        title: "Data rozładunku",
        bold: true
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(_unref(CardText), { title: "Koszt przewoźnika" })
    ])
  ]))
}
}

})